import { render, staticRenderFns } from "./layoutSidebar.vue?vue&type=template&id=b930d76a&scoped=true&"
import script from "./layoutSidebar.vue?vue&type=script&lang=js&"
export * from "./layoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./layoutSidebar.vue?vue&type=style&index=0&id=b930d76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b930d76a",
  null
  
)

export default component.exports